import { render, staticRenderFns } from "./ListAssetsResale.vue?vue&type=template&id=2dddee61"
import script from "./ListAssetsResale.vue?vue&type=script&lang=js"
export * from "./ListAssetsResale.vue?vue&type=script&lang=js"
import style0 from "./ListAssetsResale.vue?vue&type=style&index=0&id=2dddee61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports